import { Injectable } from "@angular/core";
import { StreamAudio, CaptureStreamAudioVolumeData } from "youm-lib";
import { defer, of } from "rxjs";
import { concatMap, map, tap } from "rxjs/operators";

@Injectable()
export class MicVolumeService {
  private _volumeData: null | CaptureStreamAudioVolumeData = null;

  monitor(stream: MediaStream) {
    return defer(() =>
      this._volumeData
        ? StreamAudio.releaseVolume(this._volumeData)
        : of(void 0)
    ).pipe(
      map(() => StreamAudio.captureVolume(stream)),
      tap((_) => (this._volumeData = _)),
      concatMap((_) => _.values$)
    );
  }
}
